import { render, staticRenderFns } from "./FiltroFormatacao.vue?vue&type=template&id=595d5ed5&"
import script from "./FiltroFormatacao.vue?vue&type=script&lang=js&"
export * from "./FiltroFormatacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\07.00\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('595d5ed5')) {
      api.createRecord('595d5ed5', component.options)
    } else {
      api.reload('595d5ed5', component.options)
    }
    module.hot.accept("./FiltroFormatacao.vue?vue&type=template&id=595d5ed5&", function () {
      api.rerender('595d5ed5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Contabil/balancete/FiltroFormatacao.vue"
export default component.exports